import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isEqual from 'lodash/isEqual';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import useContainerSize from '@/hooks/useContainerSize';
import { ButtonV2 as Button } from '@/components/Button';
import globalEvents from '@/utils/globalEvents';
import { useAccordion } from '@/components/Accordion';
import redirectUser from '@/utils/redirectUser';
import Accordion from '@/components/Accordion';
import Tooltip from '@/components/Tooltip';
import logger from '@/utils/logger';
import getSectionElementId from '@/components/widget/utils/getSectionElementId';
import { getEditingAreaAttr, getEditingAreaMetaDataAttr } from '@/components/Editor/hooks/useEditingAreas';
import settings from './settings';
import StyleVariables, { getSectionAttr, getSectionAttrSelector } from '../misc/StyleVariables';
import Question from './Question';
import QuestionGroup from './QuestionGroup';
import useLocalConfig from './useLocalConfig';
import useDefaultValueMergedQuestions from './useDefaultValueMergedQuestions';
import useLoadWorkbookData from './useLoadWorkbookData';
import useCreateResults from './useCreateResults';
import useValidation from './useValidation';
import useSaveChange from './useSaveChange';
import useSharing from './useSharing';
import useQuestionsReavealFilter from './useQuestionsReavealFilter';
import useQuestionGroups from './useQuestionGroups';
import styles from './styles.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LinkIcon = function LinkIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.7031 1.66693C12.4766 1.65619 11.296 2.13108 10.4155 2.98748L10.4069 2.99595L9.74681 3.65676C9.42156 3.98238 9.4219 4.51002 9.74748 4.83527C10.0731 5.16052 10.6008 5.16022 10.9261 4.83459L11.5816 4.1783C12.1481 3.62934 12.9046 3.32668 13.6885 3.33353C14.4743 3.34041 15.2272 3.65778 15.7846 4.21913C16.3423 4.78068 16.6596 5.54151 16.6665 6.33808C16.6733 7.13237 16.371 7.89659 15.826 8.46733L13.5288 10.7807C13.224 11.0878 12.8575 11.3248 12.4544 11.4763C12.0513 11.6277 11.6208 11.69 11.192 11.659C10.7632 11.6281 10.3457 11.5047 9.96798 11.2968C9.59023 11.089 9.26073 10.8015 9.00223 10.4535C8.72781 10.084 8.20581 10.007 7.83635 10.2814C7.46689 10.5558 7.38985 11.0778 7.6643 11.4473C8.065 11.9868 8.57656 12.4336 9.16456 12.7571C9.75265 13.0806 10.4031 13.2732 11.0721 13.3214C11.7411 13.3697 12.4124 13.2724 13.0405 13.0365C13.6685 12.8006 14.2384 12.4315 14.7116 11.9548L17.014 9.63633L17.0241 9.62592C17.8742 8.73958 18.3437 7.55358 18.3331 6.3237C18.3225 5.09381 17.8326 3.91618 16.9672 3.04474C16.1017 2.17312 14.9296 1.67766 13.7031 1.66693Z",
      fill: "#3A3D4D"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.92779 6.67878C8.25883 6.63054 7.58751 6.72775 6.95943 6.96368C6.33142 7.19959 5.76148 7.56868 5.28827 8.04534L2.98588 10.3638L2.97577 10.3742C2.12563 11.2606 1.65619 12.4466 1.6668 13.6765C1.67742 14.9063 2.16726 16.084 3.03263 16.9554C3.89819 17.8271 5.07029 18.3225 6.29682 18.3332C7.52335 18.344 8.70388 17.8691 9.58446 17.0127L9.59471 17.0025L10.251 16.3417C10.5752 16.0151 10.5734 15.4875 10.2468 15.1632C9.92021 14.8389 9.39263 14.8407 9.06829 15.1673L8.41754 15.8227C7.85107 16.3711 7.09498 16.6735 6.3114 16.6667C5.52558 16.6597 4.77269 16.3424 4.21524 15.781C3.65761 15.2195 3.34029 14.4587 3.33341 13.6621C3.32655 12.8677 3.62895 12.1036 4.17391 11.5328L6.4711 9.2195C6.77594 8.91241 7.14244 8.67533 7.54552 8.52391C7.94859 8.3725 8.37904 8.3102 8.80788 8.34116C9.23671 8.37208 9.65413 8.4955 10.0319 8.70333C10.4097 8.91116 10.7391 9.19866 10.9976 9.54666C11.2721 9.91616 11.794 9.99316 12.1635 9.71875C12.533 9.44433 12.61 8.92233 12.3356 8.55283C11.9349 8.0134 11.4233 7.5666 10.8353 7.24309C10.2473 6.91956 9.59671 6.72702 8.92779 6.67878Z",
      fill: "#3A3D4D"
    })]
  }));
};

LinkIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const WidgetForm = _ref => {
  let {
    widgetId,
    sectionId,
    reportingWidgetId,
    widgetElementId,
    elementId,
    editing = false,
    disabled = false,
    config,
    sectionsIndex,
    questionsReady = false,
    workbookUrl,
    workbook: localWorkbookData,
    workbookMeta,
    noFormHTML = false,
    onChange = () => undefined,
    onSubmit = () => undefined,
    onDidSubmit = () => undefined
  } = _ref;
  const formElement = useRef(null); // TODO: replace with react-use hook

  const containerSize = useContainerSize(formElement);
  const {
    questions: srcQuestions = [],
    ctaButton = 'Submit',
    ctaButtonColor,
    submitOnLoad = true,
    resultsDestination = '',
    groups = [],
    localConfigId = '',
    shareHashId = '',
    shareable = false,
    saveSession = true,
    saveLocally = false
  } = config; // Allow report generation if the widget is in editing mode

  const {
    0: isDisabled,
    1: setIsDisabled
  } = useState(disabled && !editing);
  const {
    0: submitTimeoutId,
    1: setSubmitTimeoutId
  } = useState(null);
  const {
    questions: localConfigQuestions
  } = useLocalConfig({
    localConfigId,
    sourceQuestions: srcQuestions
  });
  const {
    data: mergedQuestions,
    status: questionsStatus
  } = useDefaultValueMergedQuestions({
    sourceQuestions: srcQuestions,
    localConfigQuestions,
    shareable,
    saveSession,
    saveLocally
  });
  const questions = useQuestionsReavealFilter({
    questions: questionsStatus === 'success' ? mergedQuestions : []
  });
  const {
    isValid,
    broadcastValidationChanges
  } = useValidation(questions, formElement && formElement.current || null);
  const canQuestionsRender = questionsStatus === 'success' || questionsReady; // Use local or request remote workbook

  const {
    data: workbookData,
    remoteWorkbookUpdatedAt,
    currentWorkbookDigest
  } = useLoadWorkbookData({
    widgetId,
    workbookUrl,
    localWorkbookData,
    onError: logger.error
  });
  const {
    publishAll
  } = useCreateResults(reportingWidgetId, workbookData, workbookMeta // TODO:
  // onError
  );
  const {
    groupedQuestions,
    initialOpenGroups,
    isTogglingEnabled: isGroupTogglingEnabled
  } = useQuestionGroups(groups, questions);
  const {
    saveQuestionAnswer,
    saveFormAnswers
  } = useSaveChange({
    questions,
    srcQuestions,
    saveSession,
    saveLocally
  });
  const {
    saveShareLinkToClipboard
  } = useSharing(questions, `${shareHashId || widgetElementId || ''}`.replace(/^#/, ''));
  const {
    openPanels,
    togglePanel
  } = useAccordion(initialOpenGroups); // User configured styles

  let ctaButtonStyles = '';

  if (ctaButtonColor && typeof ctaButtonColor === 'string') {
    ctaButtonStyles += `background-color: ${ctaButtonColor} !important; border-color: ${ctaButtonColor} !important;`;
  } // Generate new reports


  const subscription = useRef();
  const handleSubmit = useCallback(evt => {
    if (!isValid) return;
    if (isDisabled) return; // Submission in progress or widget disabled
    // Cancel any outstanding timeouts
    // to prevent double submissions

    unsubscribeActivePublishing();
    setIsDisabled(true);
    evt && evt.preventDefault(); // DEPRECATED

    globalEvents.trigger('questionnaireloading', {
      detail: reportingWidgetId
    });
    globalEvents.trigger('formloading', {
      detail: reportingWidgetId
    });
    subscription.current = publishAll(getFormsElements(formElement), questions, () => {
      // DEPRECATED
      globalEvents.trigger('questionnairesubmit', {
        detail: reportingWidgetId
      });
      globalEvents.trigger('formsubmit', {
        detail: reportingWidgetId
      });
      onDidSubmit();
      subscription.current = null;
      setIsDisabled(false);
    }, // Handle error with report creation
    // and allow users to update form
    // and resubmit
    err => {
      logger.error(err); // @ts-ignore

      if (err.items) logger.log(err.items);
      subscription.current = null;
      setIsDisabled(false);
    });
    onSubmit();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [questions, onDidSubmit, onSubmit, reportingWidgetId, publishAll, subscription, isValid, unsubscribeActivePublishing, currentWorkbookDigest]); // Interrupt any active publishing
  // when there's newer user data available
  // eslint-disable-next-line react-hooks/exhaustive-deps

  function unsubscribeActivePublishing() {
    if (submitTimeoutId) {
      clearTimeout(submitTimeoutId);
      setSubmitTimeoutId(null);
    }

    if (subscription.current) {
      subscription.current.unsubscribe();
    }
  } // Wait for form submit to
  // redirect user to optional result dest


  const handleSubmitRequest = evt => {
    if (evt instanceof Event) {
      evt.preventDefault();
      evt.stopPropagation();
    } // Unqueue any submissions in progress


    unsubscribeActivePublishing(); // Update invalids immediately

    const invalids = broadcastValidationChanges(); // Focus on first invalid element
    // and exit before regenerating results

    if (invalids.length) {
      // @ts-ignore
      typeof invalids[0].focus === 'function' && !document.hasFocus() && // user not focusing
      // @ts-ignore
      invalids[0].focus();
      return;
    }

    const unsubscribe = globalEvents.subscribe('formsubmit', evt => {
      // Ignore other forms
      if (!evt || evt.detail !== reportingWidgetId) return;
      unsubscribe(); // Transition user to results

      requestAnimationFrame(() => {
        // Scroll to:
        // 1) Custom result destination...
        // 2) Next section, after this form
        const finalResultDest = resultsDestination || `#${getSectionElementId({
          widgetId,
          sectionIndex: sectionsIndex + 1
        })}`;
        redirectUser(finalResultDest, null, true // Only scroll if not visible
        );
      });
    }); // Invoke immediately

    handleSubmit();
  }; // Request validation of a question


  const triggerQuestionValidation = questionId => {
    requestAnimationFrame(() => broadcastValidationChanges(questionId));
  }; // Validate + Set timeout to initiate submit


  const handleFormChange = questionId => {
    // Unqueue submissions in progress
    unsubscribeActivePublishing(); // Allow form changes to propagate

    requestAnimationFrame(() => {
      // Validate
      const invalids = broadcastValidationChanges(questionId || ''); // Queue submission

      if (invalids.length === 0) {
        setSubmitTimeoutId(setTimeout(() => {
          globalEvents.trigger('forminternalresubmit', {
            detail: reportingWidgetId
          });
        }, 1500));
      }
    });
  }; // Copy share link to clipboard
  // and alert user of the result


  const handleShare = () => {
    if (!isValid) return;
    saveShareLinkToClipboard(getFormsElements(formElement)).then(() => alert('Share link is copied to your clipboard')).catch(() => alert('Failed to copy share link to your clipboard'));
  }; // Submit form on load, after
  // questions have been rendered
  // const [didSubmitOnLoad, setDidSubmitOnLoad] = useState(false);


  const didSubmitOnLoad = useRef(false);
  useEffect(() => {
    if (submitOnLoad && !didSubmitOnLoad.current && canQuestionsRender && workbookData) {
      // Ensure submit after render so latest
      // form state generates new results
      requestAnimationFrame(() => handleSubmit());
      didSubmitOnLoad.current = true;
    }
  }, [didSubmitOnLoad, canQuestionsRender, handleSubmit, submitOnLoad, workbookData]); // Update results on local workbook data changes

  const lastLocalWorkbook = useRef(localWorkbookData);
  useEffect(() => {
    if (!localWorkbookData || !canQuestionsRender) return;

    if (!isEqual(lastLocalWorkbook.current, localWorkbookData)) {
      requestAnimationFrame(() => handleSubmit());
      lastLocalWorkbook.current = localWorkbookData;
    }
  }, [canQuestionsRender, handleSubmit, localWorkbookData]); // Update results on remote workbook sync changes

  const lastRemoteWorkbookUpdate = useRef(0);
  useEffect(() => {
    if (!remoteWorkbookUpdatedAt) return;
    if (lastRemoteWorkbookUpdate.current === remoteWorkbookUpdatedAt) return;
    requestAnimationFrame(() => handleSubmit());
    lastRemoteWorkbookUpdate.current = remoteWorkbookUpdatedAt;
  }, [remoteWorkbookUpdatedAt, handleSubmit]);

  const handleChange = (question, value) => {
    // Bubble up change
    onChange(question.id, value); // Save to enabled stores

    saveQuestionAnswer(question, value);
  }; // Subscribe to resubmit/recalculate
  // requests from broadcast events


  useEffect(() => {
    // DEPRECATED
    const unsubscribeDep = globalEvents.subscribe('questionnaireresubmit', evt => {
      if (!evt || evt.detail !== reportingWidgetId) return;
      handleSubmitRequest();
    });
    const unsubscribe = globalEvents.subscribe('formresubmit', evt => {
      if (!evt || evt.detail !== reportingWidgetId) return;
      handleSubmitRequest();
    }); // Create reports without validation
    // and redirection to results

    const unsubscribeInternal = globalEvents.subscribe('forminternalresubmit', evt => {
      if (!evt || evt.detail !== reportingWidgetId) return;
      handleSubmit();
    });
    return () => {
      unsubscribe();
      unsubscribeDep();
      unsubscribeInternal();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, currentWorkbookDigest]); // Subscribe to save requests
  // from broadcast events

  useEffect(() => {
    // DEPRECATED
    const unsubscribeDep = globalEvents.subscribe('questionnairesave', evt => {
      if (!evt || evt.detail !== reportingWidgetId) return;
      saveFormAnswers(getFormsElements(formElement));
    });
    const unsubscribe = globalEvents.subscribe('formsave', evt => {
      if (!evt || evt.detail !== reportingWidgetId) return;
      saveFormAnswers(getFormsElements(formElement));
    });
    return () => {
      unsubscribe();
      unsubscribeDep();
    };
  }, [questions, formElement, reportingWidgetId, saveFormAnswers]);
  const isTwoColumnLayout = containerSize.width >= 378;

  if (noFormHTML) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsxs("form", _objectSpread(_objectSpread(_objectSpread({
    ref: formElement,
    className: styles.container
  }, elementId && {
    id: elementId
  }), {}, {
    onSubmit: handleSubmit,
    onChange: evt => {
      var _evt$target;

      // @ts-ignore
      handleFormChange((evt === null || evt === void 0 ? void 0 : (_evt$target = evt.target) === null || _evt$target === void 0 ? void 0 : _evt$target.id) || '');
    }
  }, getSectionAttr(widgetId, sectionId)), {}, {
    children: [/*#__PURE__*/_jsx("fieldset", {
      className: styles.fields,
      children: canQuestionsRender && /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Accordion, {
          containerClassName: styles.questionGroups,
          children: groupedQuestions.map((questionGroup, groupIndex) => {
            const groupConfig = groups[groupIndex] || {};
            const isTogglible = Boolean(isGroupTogglingEnabled && groupConfig.isToggleable);
            return /*#__PURE__*/_jsx(QuestionGroup, {
              className: isTwoColumnLayout ? styles.gridFields : '',
              heading: groupConfig.heading,
              isOpen: !isTogglible || openPanels.includes(groupIndex),
              isToggleable: isTogglible,
              onClick: () => togglePanel(groupIndex),
              children: questionGroup.map(question => {
                return /*#__PURE__*/_jsx(Question, {
                  data: question,
                  editing: editing,
                  formElement: formElement.current || undefined,
                  onChange: handleChange,
                  disabled: isDisabled,
                  triggerValidation: () => triggerQuestionValidation(question.id),
                  triggerChange: () => handleFormChange(question.id)
                }, `${widgetId}-${sectionsIndex}-question-${question.id}-${question.selections}`);
              })
            }, `${widgetId}-${sectionsIndex}-group-${groupIndex}`);
          })
        })
      })
    }), ctaButtonColor ? /*#__PURE__*/_jsx("style", {
      type: "text/css",
      children: `.${styles.actions__primaryButton}:not(:disabled):hover {${ctaButtonStyles}}`
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsxs("div", {
      className: styles.actions,
      children: [shareable ? /*#__PURE__*/_jsx(Tooltip, {
        placement: "right",
        className: styles.heading__warning,
        content: 'Create link to current results',
        children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          size: "large",
          type: "button",
          className: styles.actions__shareButton
        }, !isValid && {
          disabled: true
        }), {}, {
          onClick: handleShare,
          children: /*#__PURE__*/_jsx(LinkIcon, {})
        }))
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        className: styles.actions__primaryButton
      }, (isDisabled || !isValid) && {
        disabled: true
      }), editing && {
        [getEditingAreaAttr()]: 'button'
      }), editing && {
        [getEditingAreaMetaDataAttr()]: '{}'
      }), {}, {
        size: "large",
        type: "button",
        onClick: evt => handleSubmitRequest(evt),
        children: ctaButton
      }))]
    }), /*#__PURE__*/_jsx(StyleVariables, {
      selector: getSectionAttrSelector(widgetId, sectionId),
      data: _objectSpread(_objectSpread({}, settings.styles), config.styles || {})
    })]
  }));
};

export default WidgetForm;
export { settings }; // Lookup elements associated
// with the rendered form element

function getFormsElements(formElement) {
  if (formElement && formElement.current) {
    const form = formElement.current;
    return form.elements;
  }
}